import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import style from './index.module.scss';

function TopicTabs(props) {
  const { topicName } = props;
  
  return (
    <nav className={`col-12 ${style.nav}`}>
      <NavLink
        className={style['nav-link']}
        activeClassName={style.active}
        exact
        to={`/topic/${topicName}`}
      >
        Read
      </NavLink>
      <NavLink
        className={style['nav-link']}
        activeClassName={style.active}
        to={`/topic/${topicName}/answer`}
      >
        Answer
      </NavLink>
      <NavLink
        className={style['nav-link']}
        activeClassName={style.active}
        to={`/topic/${topicName}/top-writers`}
      >
        Most Viewed Writers
      </NavLink>
      <NavLink
        className={`${style['nav-link']} ${style['nav-link--related']}`}
        activeClassName={style.active}
        to={`/topic/${topicName}/related`}
      >
        Related Topics
      </NavLink>
    </nav>
  )
}

TopicTabs.propTypes = {
  topicName: PropTypes.string.isRequired,
};

export default TopicTabs;
